.gas-membership-plans-list {
    max-width: var(--gas-container-wide, 1100px);
    margin: 0 auto;
    padding: var(--gas-space-xl, 20px) var(--gas-space-md, 10px);
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-lg, 15px);
}

.gas-membership-plans-list__header {
    text-align: center;
}

.gas-membership-plans-list__title {
    margin: 0;
    font-size: var(--gas-font-size-2xl, 20px);
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__subtitle {
    margin: var(--gas-space-xs, 2.5px) 0 0;
    color: var(--gas-color-text-muted, #666);
}

.gas-membership-plans-list__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: var(--gas-space-lg, 15px);
}

.gas-membership-plans-list__card {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-md, 10px);
    padding: var(--gas-space-lg, 15px);
    border: 1px solid var(--gas-color-border, #e2e6ee);
    border-radius: var(--gas-radius-lg, 12px);
    background: var(--gas-color-surface, #fff);
}

.gas-membership-plans-list__card-media {
    display: block;
    margin: calc(-1 * var(--gas-space-lg, 15px)) calc(-1 * var(--gas-space-lg, 15px)) 0;
    overflow: hidden;
    border-radius: var(--gas-radius-lg, 12px) var(--gas-radius-lg, 12px) 0 0;
}

.gas-membership-plans-list__card-image {
    width: 100%;
    height: 160px;
    object-fit: cover;
    display: block;
}

.gas-membership-plans-list__card-title {
    margin: 0;
    font-size: var(--gas-font-size-lg, 12.5px);
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__card-link {
    color: inherit;
    text-decoration: none;
}

.gas-membership-plans-list__card-link:hover {
    text-decoration: underline;
}

.gas-membership-plans-list__card-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--gas-space-sm, 5px);
    margin: 0;
}

.gas-membership-plans-list__price {
    font-size: var(--gas-font-size-xl, 15px);
    font-weight: 700;
    color: var(--gas-color-primary, #2d6cdf);
}

.gas-membership-plans-list__period {
    color: var(--gas-color-text-muted, #666);
}

.gas-membership-plans-list__badge {
    display: inline-block;
    padding: var(--gas-space-2xs, 1.25px) var(--gas-space-sm, 5px);
    border-radius: var(--gas-radius-pill, 999px);
    background: var(--gas-color-surface-alt, #eef2fb);
    color: var(--gas-color-primary, #2d6cdf);
    font-size: var(--gas-font-size-sm, 8.5px);
}

.gas-membership-plans-list__card-description {
    margin: 0;
    line-height: 1.6;
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__features {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2xs, 2.5px);
}

.gas-membership-plans-list__feature {
    position: relative;
    padding-left: var(--gas-space-md, 10px);
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__feature::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: var(--gas-color-success, #2e9e5b);
}

.gas-membership-plans-list__notice {
    margin: 0;
    padding: var(--gas-space-sm, 5px) var(--gas-space-md, 10px);
    border-left: 3px solid var(--gas-color-warning, #e0a800);
    background: var(--gas-color-surface-alt, #fff8e6);
    color: var(--gas-color-text, #1a1a1a);
    border-radius: var(--gas-radius-sm, 4px);
}

.gas-membership-plans-list__card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-sm, 5px);
    margin-top: auto;
}

.gas-membership-plans-list__empty {
    text-align: center;
    color: var(--gas-color-text-muted, #666);
    padding: var(--gas-space-xl, 20px) 0;
}

.gas-membership-plans-list__advisor {
    text-align: center;
    margin-top: var(--gas-space-md, 10px);
}
